export function getEndIndex(page, paging, count) {
  const maxPage = Math.ceil(count / paging);
  let endIndex = page * paging + paging;
  if (page +1 >= maxPage && count % paging !== 0) {
    endIndex = page * paging + count % paging;
  }
  return endIndex;
}

export function getPageLinks(page, paging, count, intl) {
  const maxPage = Math.ceil(count / paging);
  const pageLinks = [];
  if (maxPage <= 1) {
    return pageLinks;
  }
  const prevText = intl.formatMessage({ id:'app.feedback.paging.prev'});
  const nextText = intl.formatMessage({ id:'app.feedback.paging.next'});
  pageLinks.push({ 'text': prevText, 'style': page === 0 ? 'disabled' : '', 'value': page - 1 });
  let skip = false;
  for (let i = 0; i < maxPage; i++) {
    if (i === 0 || i === maxPage - 1 || Math.abs(i - page) < 3) {
      pageLinks.push({ 'text': i + 1, 'style': page === i ? 'active' : '', 'value': i });
      skip = true;
    } else if (skip) {
      pageLinks.push({ 'text': '…', 'style': 'disabled', 'value': i });
      skip = false;
    }
  }
  pageLinks.push({ 'text': nextText, 'style': page === maxPage - 1 ? 'disabled' : '', 'value': page + 1 });

  return pageLinks;
}

export function getOrder (column, order, direction) {
  if (column === order) {
    if (direction === 'ASC') {
      return 'sorting_asc';
    } else {
      return 'sorting_desc';
    }
  }
  return 'sorting';
}
